import SocialMedia from "./SocialMedia";
import { useState, useEffect } from "react";

const Footer = ({ hideOnMobileChat = false }) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 640;
    }
    return false;
  });

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Hide footer on mobile when chat input is at bottom
  if (hideOnMobileChat && isMobile) {
    return null;
  }

  return (
    <footer className="flex flex-col md:flex-row items-center justify-between text-xs space-x-2 space-y-0 min-h-0"
      style={{ backgroundColor: 'var(--bg-secondary)', paddingTop: '1.5rem', paddingBottom: '1.5rem' }}>
      {/* Social Media moves to the top in mobile view */}
      <div className="order-1 md:order-3 md:mt-0 flex items-center space-x-2 pr-4 md:pr-6">
        <span style={{ color: 'var(--text-secondary)' }}> </span>
        <SocialMedia />
      </div>

      {/* Copyright stays in the middle */}
      <p className="order-2 md:order-2 md:mt-0" style={{ color: 'var(--text-secondary)' }}>© {new Date().getFullYear()} limkc. All rights reserved.</p>

      {/* Links (Privacy, Terms, etc.) move to the bottom in mobile view */}
      <div className="flex space-x-3 order-3 md:order-1">
        <a href="/privacy" className="hover:underline" style={{ color: 'var(--text-secondary)' }}>Privacy Policy</a> 
        <a href="/terms" className="hover:underline" style={{ color: 'var(--text-secondary)' }}>Terms & Conditions</a> 
        <a href="/disclaimer" className="hover:underline" style={{ color: 'var(--text-secondary)' }}>Disclaimer</a>
      </div>
    </footer>
  );
};

export default Footer;
